// import {store1} from '../store/index's

var DataStore = require('../store');
var store = DataStore.default

const fetchPOST = () => {
  return store.state.kamio
}


const getopdterlapor = () => {
  fetch(store.state.url.URL_DM_OPD_TERLAPOR + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_opdterlapor = res_data
    // console.log(res_data)
  })
}

const getkategoripenolakan = () => {
  fetch(store.state.url.URL_DM_KATEGORI_PENOLAKAN + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_kategoripenolakan = res_data
    // console.log(res_data)
  })
}


module.exports = {
  fetchPOST: fetchPOST,
  getopdterlapor: getopdterlapor,
  getkategoripenolakan: getkategoripenolakan
}